import React, { useContext } from 'react';
import { Modal } from 'react-bootstrap';
import { ApiContext } from '../../../UseContext/ApiCall';
import { AwsFileUrl, BASE_URL_STATIC } from '../../../../../config';


const CnpTagPopup = () => {

  const {
    cnpTagAxis, 
    cnpSelectedPhotoVideo, setCnpSelectedPhotoVideo,
    setShowCnpTagsOnPhoto,
    handleCnpOpenPreviousPopup,

    showCnpTagPopup, setShowCnpTagPopup,
    showCnpTagLoadMore,
    cnpTagSearchText, setCnpTagSearchText,
    cnpTagSearched, setCnpTagSearched,
    getTagSearched,
  } = useContext(ApiContext);


  // handle search 
  const handleSearch = (e) => {
    setCnpTagSearchText(e.target.value);

    getTagSearched(e.target.value, 0);
  };

  // handle select user for taggin
  const handleSelectUserToTag = (user) => {

    // remove from cnp tag searched
    setCnpTagSearched(preState => preState.filter(value => value._id !== user._id));

    // add to cnp selected photo/video tags
    setCnpSelectedPhotoVideo(preState => {
      const updated = [...preState];

      const index = cnpTagAxis.index;
  
      const updatedItem = {
        ...updated[index],
        tags: [
          ...updated[index].tags,
          { 
            ...user, 
            offsetX: cnpTagAxis.offsetX,
            offsetY: cnpTagAxis.offsetY,
          }
        ]
      };
  
      updated[index] = updatedItem;

      return updated;
    });

    if((cnpSelectedPhotoVideo[cnpTagAxis && cnpTagAxis.index] !== undefined) && (cnpSelectedPhotoVideo[cnpTagAxis && cnpTagAxis.index].file) && (cnpSelectedPhotoVideo[cnpTagAxis && cnpTagAxis.index].file.type.includes('image'))) {
      setShowCnpTagPopup(false);
      setShowCnpTagsOnPhoto(true);
      setCnpTagSearchText('');
      setCnpTagSearched([]);
    };

    handleCnpOpenPreviousPopup();
  };

  // handle remove tagged user
  const handleRemoveTaggedUser = (photoVideoIndex, taggedUserId) => {
    setCnpSelectedPhotoVideo(prevState => {
      const updated = [...prevState];
  
      if (updated[photoVideoIndex]) {
        updated[photoVideoIndex] = {
          ...updated[photoVideoIndex],
          tags: updated[photoVideoIndex].tags.filter(tag => tag._id !== taggedUserId)
        };
      };
  
      return updated;
    });
  };
  
  

  // handle load more 
  const handleLoadMore = () => {
    getTagSearched(cnpTagSearchText, cnpTagSearched.length);
  };


  // handle close tag popup
  const handleCloseTagPopup = () => {
    setShowCnpTagPopup(false);

    setCnpTagSearchText('');
    setCnpTagSearched([]);

    handleCnpOpenPreviousPopup();
  };



  return (
    <>
      <Modal show={showCnpTagPopup} onHide={handleCloseTagPopup} centered backdrop="static" keyboard={false} className="main-modal" >
      {/* <Modal show={true} onHide={handleCloseTagPopup} centered backdrop="static" keyboard={false} className="main-modal" > */}
        <Modal.Header className='pt-0' closeButton>
          <h5 className='flex-grow-1 text-center pt-3'>Tag</h5>
        </Modal.Header>

        <Modal.Body>
          {/* Search Bar */}
          <div className="d-flex flex-grow-1 rounded-pill bg-body-secondary p-1 p-sm-2 my-3">
            <img className="mx-2" src={`${BASE_URL_STATIC}/icon/search.svg`} alt="search" />

            <input type="search" className="rounded-pill bg-body-secondary w-100 border-0" id="search" name="search" autoComplete='off' placeholder={`Search here...`} 
              value={cnpTagSearchText} onChange={handleSearch}
            />
          </div>

          {/* Added */}
          <>
            {
              ((cnpSelectedPhotoVideo[cnpTagAxis && cnpTagAxis.index] !== undefined) && (cnpSelectedPhotoVideo[cnpTagAxis && cnpTagAxis.index]['tags'].length > 0))
              &&
              <div>
                <h5 className='mb-3'>Added</h5>

                <div className={`${(cnpSelectedPhotoVideo[cnpTagAxis && cnpTagAxis.index]['tags'].length > 3) && 'overflow-y-scroll'} pe-2`} style={{ maxHeight: '25vh' }}>
                  {
                    cnpSelectedPhotoVideo[cnpTagAxis && cnpTagAxis.index]['tags'].map((value, index) => (
                      <div className='d-flex align-items-center gap-3 mb-3' key={index}>
                        <img src={AwsFileUrl+value.profile} className='rounded-circle' style={{ height: '40px', width: '40px' }} alt="profile" />                  

                        <div className='me-auto'>
                          <h5 className='mb-0'>{value.name}</h5>
                          <span className='text-secondary'>{value.userName}</span>
                        </div>

                        <button type="button" className='btn btn-warning btn-sm' onClick={() => handleRemoveTaggedUser(cnpTagAxis.index, value._id)} >Remove</button>
                      </div>
                    ))
                  }
                </div>

                <hr className='hr' />
              </div>
            }
          </>

          {/* Searched */}
          <>
            {
              (cnpTagSearched && cnpTagSearched.length > 0)
              ?
              <div>
                <h5 className='mb-3'>Searched</h5>
    
                <div className={`${cnpTagSearched.length > 3 && 'overflow-y-scroll'} pe-2`} style={{ maxHeight: '25vh' }}>
                  {
                    cnpTagSearched.map((value, index) => (
                      <div className='d-flex align-items-center gap-3 mb-3 cursor-pointer' key={index}>
                        <img src={AwsFileUrl+value.profile} className='border rounded-circle' style={{ height: '40px', width: '40px' }} alt="profile" />

                        <div className='me-auto'>
                          <h5 className='mb-0'>{value.name}</h5>
                          <span className='text-secondary'>{value.userName}</span>
                        </div>

                        <button type="button" className='btn btn-primary btn-sm' onClick={() => handleSelectUserToTag(value)}>Add</button>
                      </div>
                    ))
                  }

                  {/* Load More */}
                  <>
                    {
                      showCnpTagLoadMore
                      ?
                      <div className='text-center'>
                        <button type="button" className='btn btn-primary btn-sm mt-3 mb-1' onClick={handleLoadMore}>Load More</button>
                      </div>
                      :
                      <div className='text-center text-secondary'>No more users...</div>
                    }
                  </>
                </div>
              </div>
              :
              <div className='text-center text-secondary'>No Results...</div>
            }
          </>
        </Modal.Body>
      </Modal>
    </>
  )
}

export default CnpTagPopup;